import { api } from "@/services";
import { useFilter, useSintegraRegistrations } from "@/utilsV2";
import { ActivitieObject, Corporate, SintegraObjects } from "@/types";

type useCnpj = {
  tax_id: string;
  error?: boolean;
  errorMessage?: string | null;
  ie?: string | null;
  ClientPJData?: Corporate | UseReturn;
};

type UseReturn = {
  tax_id: string;
  error: string;
  valid: boolean;
} & {
  sintegra?: SintegraObjects;
  address?: { state: string };
  secondary_activities?: ActivitieObject[];
  primary_activity?: ActivitieObject;
};

async function useCnpj(cnpj: string) {
  const CNPJ = useFilter(cnpj, { type: "number" });

  const Response = await api
    .get(`/Corporate/${CNPJ}`)
    .then(({ data, status }) => {
      if (status === 200) {
        const resp: Corporate = {
          ...data,
          valid: true
        };
        return resp;
      } else {
        const resp: UseReturn = {
          tax_id: CNPJ,
          error: "Não foi possível encontrar o CNPJ informado.",
          valid: false
        };
        return resp;
      }
    })
    .catch(() => {
      const resp: UseReturn = {
        tax_id: CNPJ,
        error: "Não foi possível buscar o CNPJ",
        valid: false
      };
      return resp;
    });

  if (Response.valid === false) {
    const ResponseData: useCnpj = {
      tax_id: Response.tax_id,
      error: true,
      errorMessage: Response.error,
      ie: null,
      ClientPJData: null
    };
    return ResponseData;
  }

  const GetSintegra = useSintegraRegistrations(
    Response.sintegra,
    Response.address.state,
    Response.secondary_activities.concat(Response.primary_activity),
    CNPJ
  );

  if (GetSintegra.error) {
    const ResponseData: useCnpj = {
      tax_id: Response.tax_id,
      error: true,
      errorMessage: GetSintegra.errorMessage,
      ie: null,
      ClientPJData: null
    };
    return ResponseData;
  } else {
    const ResponseData: useCnpj = {
      tax_id: Response.tax_id,
      error: false,
      errorMessage: null,
      ie: GetSintegra.ie,
      ClientPJData: Response
    };
    return ResponseData;
  }
}

export { useCnpj };
